<div id="jupiter-block-dialog-container">
  <div id="img-container">
    <div id="rocket"></div>
  </div>
  <p class="heading-02-semi-bold grey-900">
    Gracias por tu interés en las funcionalidades de Júpiter. Hemos <br />
    recibido tu consulta y pronto nos pondremos en contacto.
  </p>
</div>
